module.exports = __webpack_public_path__ + "img/calendar.f51dd339.svg";